
const namespaced = true
const state = {
  isShowFilter: false,
  selected: [],
  filteredParts: null
}

const getters = {}
const mutations = {
  delCol (state, index) {
    state.selected.splice(index, 1)
  },
  resetFilter (state) {
    state.selected = []
    state.filteredParts = null
  }
}
const actions = {
  setFilter ({ state, dispatch }, { filter, subtable }) {
    state.selected = filter
    dispatch('filterPart', { subtable: subtable })
  },
  filterPart ({ rootState, state }, { subtable }) {
    state.filteredParts = rootState.parts.data[subtable].parts
    state.selected.forEach(el => {
      const rows = []
      state.filteredParts.forEach(part => {
        // static & field
        if (el.category === 'static' || el.category === 'field') {
          if (
            part.colIndex === el.colIndex &&
            part.data.toString().toLowerCase().includes(el.values.toString().toLowerCase())
          ) {
            rows.push(part.rowIndex)
          }
        }
        // fieldsArray
        if (el.category === 'fieldsArray' && part.colIndex === el.colIndex) {
          const check = el.values.every((elem) => {
            if (part.data.filter(data => data.includes(elem)).length > 0) return true
            else return false
          })
          if (check) rows.push(part.rowIndex)
        }
        // allowed_params
        if (el.category === 'allowed_params' && part.colIndex === el.colIndex) {
          const check = {}
          for (const key in el.values) {
            check[key] = true
            if (el.values[key].selected.length > 0) {
              check[key] = el.values[key].selected.every((elem) => {
                if (part.data[key].selected.includes(elem.toString())) return true
                else return false
              })
            }
          }
          const haveFalse = Object.values(check).find(elem => !elem)
          if (haveFalse !== false) rows.push(part.rowIndex)
        }
        // params
        if (el.category === 'params' && part.colIndex === el.colIndex) {
          const check = el.values.every((elem) => {
            if (Number(part.data[elem.key]) === elem.value) return true
            else return false
          })
          if (check) rows.push(part.rowIndex)
        }
        // paramssArray
        if (el.category === 'paramssArray' && part.colIndex === el.colIndex) {
          const check = el.values.every((elem) => {
            const arrayValue = elem.value.split(',')
            const filterVal = arrayValue.filter(data => part.data[elem.key].includes(Number(data.trim())))
            if (
              arrayValue.length > 0 && filterVal.length > 0 &&
              arrayValue.length === filterVal.length
            ) return true
            else return false
          })
          if (check) rows.push(part.rowIndex)
        }
        // attr
        if (el.category === 'attr' && part.colIndex === el.colIndex) {
          const check = el.values.every((elem) => {
            if (part.data.find(a => a.id === elem.id)) return true
            else return false
          })
          if (check) rows.push(part.rowIndex)
        }
      })
      if (rows.length === 0) state.filteredParts = []
      let filteringRow = []
      rows.forEach(rowIndex => {
        const row = state.filteredParts.filter(filteredPart => {
          return filteredPart.rowIndex === rowIndex
        })
        filteringRow = filteringRow.concat(row)
      })
      state.filteredParts = filteringRow
    })
  },
  sortPartsAZ ({ rootState, state }, { subtable, colIndex, isSortAz }) {
    state.filteredParts = rootState.parts.data[subtable].parts
    const column = state.filteredParts.filter(el => el.colIndex === colIndex)
    const filterdColumn = column.sort((a, b) => {
      if (isSortAz) {
        if (a.data > b.data) return 1
        if (a.data < b.data) return -1
      } else {
        if (a.data < b.data) return 1
        if (a.data > b.data) return -1
      }
      return 0
    })
    let sortingRow = []
    filterdColumn.forEach(el => {
      const row = state.filteredParts.filter(filteredPart => {
        return filteredPart.rowIndex === el.rowIndex
      })
      sortingRow = sortingRow.concat(row)
    })
    state.filteredParts = sortingRow
  },
  addValues ({ rootState, dispatch }, { col, subtable }) {
    let val = null
    if (col.type === 'allowed_params') {
      val = {}
      col.category = 'allowed_params'
      col.values.forEach(el => {
        val[el.name] = {
          name: el.display_name,
          possible: el.possible,
          selected: []
        }
      })
    }
    if (col.category === 'fieldsArray') val = ['']
    if (
      col.category === 'params' ||
      col.category === 'defaultparams' ||
      col.category === 'paramssArray'
    ) {
      if (col.category === 'defaultparams') col.category = 'params'
      val = [{
        key: '',
        value: ''
      }]
    }
    if (col.category === 'attr') {
      dispatch('attributes/getAllAttrInParts', { col: col, subtable: subtable }, { root: true })
      val = []
    }
    if (col.category === 'static' || col.category === 'field') {
      val = ''
    }
    return val
  },
  async selectCol ({ state, dispatch }, { col, subtable }) {
    const val = await dispatch('addValues', { col: col, subtable: subtable })
    state.selected.push({
      colIndex: col.colIndex,
      category: col.category,
      name: col.name,
      values: val
    })
  },
  async updateFilter ({ state, dispatch }, { col, index, subtable }) {
    const val = await dispatch('addValues', {
      col: col,
      subtable: subtable
    })
    state.selected[index] = {
      colIndex: col.colIndex,
      category: col.category,
      name: col.name,
      values: val
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced
}
